import { Observable } from "rxjs";

import type { ProductVariantIdProviderInterface } from "./ProductVariantIdProviderInterface";

export class ProductVariantIdFromAdditionalInfoProvider
    implements ProductVariantIdProviderInterface
{
    constructor(private readonly additionalInfoData: unknown) {}

    public selectVariantId() {
        return new Observable<number | null>((subscriber) => {
            subscriber.next(
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                (((this.additionalInfoData as any)["GW_PRODUCT_INFO"]?.[
                    "variantId"
                ] as number | null) ??
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    ((this.additionalInfoData as any)["GW_PRODUCT_INFO"]?.[
                        "defaultVariantId"
                    ] as number | null)) ||
                    null
            );
        });
    }
}
